import { useCallback, useState } from "react";

export interface FormDrawer {
    //editingId is "" while adding, which is what the add/edit forms expect
    editingId: string
    add: () => void
    edit: (id: string) => void
    close: () => void
    //drawerProps spreads onto FormDrawer
    drawerProps: {
        open: boolean
    }
}

//useFormDrawer owns the open/closed state of a list page's add-or-edit panel and
//which row it is editing.
export function useFormDrawer(): FormDrawer {
    const [editingId, setEditingId] = useState<string>();

    const add = useCallback(() => setEditingId(""), []);
    const edit = useCallback((id: string) => setEditingId(id), []);
    const close = useCallback(() => setEditingId(undefined), []);

    return {
        editingId: editingId || "",
        add,
        edit,
        close,
        drawerProps: { open: editingId !== undefined },
    };
}
